// extracted by mini-css-extract-plugin
module.exports =  {"comparisonTableTitle":"comparisonTableTitle__SvpZR","periodComparison":"periodComparison__w9chK"};